import { ref } from 'vue'
import { i18n } from '@/plugins/i18n'

const authErrorMap = {
	register: {
		UsernameExistsException: i18n.global.t(
			'authErrors.register.usernameExists',
		),
		InvalidPasswordException: i18n.global.t(
			'authErrors.register.invalidPassword',
		),
		InvalidParameterException: i18n.global.t(
			'authErrors.register.invalidParameter',
		),
		AliasExistsException: i18n.global.t('authErrors.register.aliasExists'),
		LimitExceededException: i18n.global.t('authErrors.register.limitExceeded'),
		NotAuthorizedException: i18n.global.t('authErrors.register.notAuthorized'),
		CodeMismatchException: i18n.global.t('authErrors.register.codeMismatch'),
	},
	login: {
		UserNotFoundException: i18n.global.t('authErrors.login.userNotFound'),
		NotAuthorizedException: i18n.global.t('authErrors.login.notAuthorized'),
		InvalidPasswordException: i18n.global.t('authErrors.login.invalidPassword'),
		CodeMismatchException: i18n.global.t('authErrors.login.codeMismatch'),
		UserNotConfirmedException: i18n.global.t(
			'authErrors.login.userNotConfirmed',
		),
		PasswordResetRequiredException: i18n.global.t(
			'authErrors.login.passwordResetRequired',
		),
		ExpiredCodeException: i18n.global.t('authErrors.login.expiredCode'),
	},
	resetPassword: {
		UserNotFoundException: i18n.global.t('authErrors.resetPass.userNotFound'),
		InvalidParameterException: i18n.global.t(
			'authErrors.resetPass.invalidParameter',
		),
		NotAuthorizedException: i18n.global.t('authErrors.resetPass.notAuthorized'),
		LimitExceededException: i18n.global.t('authErrors.resetPass.limitExceeded'),
		InternalErrorException: i18n.global.t('authErrors.resetPass.internalError'),
		InvalidLambdaResponseException: i18n.global.t(
			'authErrors.resetPass.invalidLambda',
		),
		InvalidSmsRoleAccessPolicyException: i18n.global.t(
			'authErrors.resetPass.invalidSmsPolicy',
		),
		CodeMismatchException: i18n.global.t('authErrors.resetPass.codeMismatch'),
		ExpiredCodeException: i18n.global.t('authErrors.resetPass.expiredCode'),
		InvalidPasswordException: i18n.global.t(
			'authErrors.resetPass.invalidPassword',
		),
	},
}

export function useAuthErrorMapper() {
	const alertMessage = ref(null)
	const alertVisible = ref(false)

	const showAuthAlert = (error, context = 'login') => {
		const fallbackMessage = i18n.global.t('authErrors.default')

		const rawCode = error?.code || error?.name || error?.__type || ''
		const cleanCode = rawCode.replace(':', '').trim()
		const contextErrors = authErrorMap[context] || {}

		alertMessage.value = contextErrors[cleanCode] || fallbackMessage
		alertVisible.value = true

		setTimeout(() => {
			alertVisible.value = false
		}, 3000)
	}

	return {
		alertMessage,
		alertVisible,
		showAuthAlert,
	}
}
